class BuildaBox extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onContentChange);
    this.buttons = this.querySelectorAll('.js-atc-button');
    this.changeEvent = new Event('change', { bubbles: true });
    this.qtyInputs = this.querySelectorAll('.quantity__input');
    this.atc = this.querySelector('.js-bab-atc');
    this.infors = this.querySelectorAll('.card__info');
    this.popups = this.querySelectorAll('.bundle-card-popup');
    this.closeButtons = this.querySelectorAll('.bundle-card-popup-close');
    this.images = this.querySelectorAll('.js-popup-image');
    this.thumbs = this.querySelectorAll('.card-popup-thumb-img');
    this.popupAtcs = this.querySelectorAll('.bundle-popup-atc');

    this.buttons.forEach((button) => {
      button.addEventListener('click', this.addItem.bind(this))
    })
    this.qtyInputs.forEach((qtyInput) => {
      qtyInput.addEventListener('change', this.onInputChange.bind(this));
    })
    this.querySelectorAll('button.quantity__button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
    this.infors.forEach(
      (infor) => infor.addEventListener('click', this.onInfoClick.bind(this))
    );
    this.images.forEach(
      (image) => image.addEventListener('click', this.onInfoClick.bind(this))
    );
    this.thumbs.forEach(
      (thumb) => thumb.addEventListener('click', this.onImageGallery.bind(this))
    );
    this.closeButtons.forEach(
      (closeButton) => closeButton.addEventListener('click', this.onPopupClose.bind(this))
    );
    this.popupAtcs.forEach(
      (popupAtc) => popupAtc.addEventListener('click', this.onPopupAtc.bind(this))
    );
    this.atc.addEventListener('click', this.buildBoxCart.bind(this));
  }

  onContentChange(){
    this.subscriptionWidgetChange();
    this.itemsChange();
    this.priceUpdate();
    this.progressUpdate();
  }

  onInputChange(event){
    this.validateQtyRules(event);
  }

  onPopupClose(event){
    this.popups.forEach((popup) => {
      popup.style.display = 'none';
    })
  }

  onPopupAtc(event){
    const contentWrap = event.target.closest('.bundle-card-product');
    const qtyInput = contentWrap.querySelector('.quantity__input');
    const inputValue = qtyInput.value;
    const productId = contentWrap.getAttribute('data-productid');

    qtyInput.value = parseInt(inputValue) + 1;
    qtyInput.dispatchEvent(this.changeEvent);
    this.popups.forEach((popup) => {
      popup.style.display = 'none';
    });
    this.itemsChange();
    this.addItemWidget(productId);
  }

  onImageGallery(event){
    const imgIndex = event.target.closest('.card-popup-thumb').getAttribute('index');
    const contentWrap = event.target.closest('.bundle-card-product');
    const images = contentWrap.querySelectorAll('.card-popup-image');

    images.forEach((image) => {
      image.classList.add('hidden');
      const iIndex = image.getAttribute('index');

      if(iIndex == imgIndex){
        image.classList.remove('hidden');
      }
    })
  }

  onInfoClick(event){
    const contentWrap = event.target.closest('.bundle-card-product');
    const popup = contentWrap.querySelector('.bundle-card-popup');

    if(popup) popup.style.display = 'block';
  }

  onButtonClick(event){
    event.preventDefault();
    const qtyWrap = event.target.closest('quantity-input');
    const previousValue = qtyWrap.querySelector('input').value;
    const cardProduct = event.target.closest('.bundle-card-product');
    const productId = cardProduct.getAttribute('data-productid');

    event.target.name === 'plus' ? qtyWrap.querySelector('input').stepUp() : qtyWrap.querySelector('input').stepDown();
    if (previousValue !== qtyWrap.querySelector('input').value) qtyWrap.querySelector('input').dispatchEvent(this.changeEvent);

    if(event.target.name === 'plus'){
      this.addItemWidget(productId);
    }else{
      this.removeItemWidget(productId);
    }
  }

  subscriptionWidgetChange(){
    const selectedOption = this.querySelector('input[name="Bab Sub Input"]:checked');
    const subOptions = this.querySelectorAll('.bab-sub-option');
    const subPrices = this.querySelectorAll('.js-sub-price');
    const onePrices = this.querySelectorAll('.js-one-price');

    //console.log(selectedOption);
    subOptions.forEach((subOption) => {
      subOption.classList.remove('active');
    })
    selectedOption.closest('.bab-sub-option').classList.add('active');

    if(selectedOption.value == 'sub'){
      subPrices.forEach((subPrice) => {
        subPrice.style.display = 'inline';
      })

      onePrices.forEach((onePrice) => {
        onePrice.classList.add('cross-price');
      })
    }else{
      subPrices.forEach((subPrice) => {
        subPrice.style.display = 'none';
      })
      onePrices.forEach((onePrice) => {
        onePrice.classList.remove('cross-price');
      })
    }
  }

  itemsChange(){
    this.buttons.forEach((button) => {
      const cardProduct = button.closest('.bundle-card-product');
      const qtyInput = cardProduct.querySelector('input[name="quantity"]');
      const qtyInputValue = qtyInput.value;
      const qtyInputWrap = cardProduct.querySelector('.card__quantity');

      if(qtyInputValue == 0){
        button.closest('.card__atc').classList.remove('added');
        qtyInputWrap.classList.remove('added');
      }else{
        button.closest('.card__atc').classList.add('added');
        qtyInputWrap.classList.add('added');
      }
    });

    //console.log(this.getTotalItems());
  }

  getTotalItems(){
    const cProducts = this.querySelectorAll('.bundle-card-product');
    const cPDetails = [];
    const selectedOption = this.querySelector('input[name="Bab Sub Input"]:checked').value;
    const freSelect = this.querySelector('select.bab-sub-select').value;

    cProducts.forEach((product) => {
      const pQty = product.querySelector('input[name="quantity"]').value;
      const productId = product.getAttribute('data-productid');
      const pSProduct = bnproductsData.find((product) => product.id == productId);
      const pSVariant = pSProduct.variants[0];
      const productSellingPlanGroups = pSProduct.selling_plan_groups;
      const productSellingPlans = productSellingPlanGroups[0].selling_plans;

      if(pSVariant.available){
        let productItem = {id: pSVariant.id, quantity: pQty};
        if(selectedOption == 'sub' && productSellingPlans && productSellingPlans.length > 0){
          const seledtedSellingPlan = productSellingPlans.find((sellingPlan) => sellingPlan.name == freSelect);
          
          if(seledtedSellingPlan){
            productItem = {id: pSVariant.id, quantity: pQty, selling_plan: seledtedSellingPlan.id};
          }
        }

        if(parseInt(pQty) > 0) cPDetails.push(productItem);

      }
    });

    return cPDetails;
  }

  addItem(event){
    const button = event.target;
    const cardProduct = button.closest('.bundle-card-product');
    const qtyInput = cardProduct.querySelector('input[name="quantity"]');
    const qtyInputValue = qtyInput.value;
    const qtyInputWrap = cardProduct.querySelector('.card__quantity');
    const productId = cardProduct.getAttribute('data-productid');

    button.closest('.card__atc').classList.add('added');
    qtyInputWrap.classList.add('added');
    qtyInput.value = parseInt(qtyInputValue) + 1;
    qtyInput.dispatchEvent(this.changeEvent);

    this.addItemWidget(productId);
  }

  addItemWidget(productId){
    const pSProduct = bnproductsData.find((product) => product.id == productId);
    let totalItemCounts = 0;
    const addedItems = this.querySelectorAll('.js-item-cell');
    let itemCellHtml;

    if(!pSProduct) return false;
    const itemIndex = addedItems.length + 1;
    const babItem = document.createElement('div');
    babItem.classList.add('bab-item-cell', 'js-item-cell');
    babItem.setAttribute('data-index', itemIndex);
    babItem.setAttribute('data-productid', pSProduct.id);

    const babItemContainer = document.createElement('div');
    babItemContainer.classList.add('bab-item-cell-container');

    const babImage = document.createElement('div');
    babImage.classList.add('bab-item-cell-img');
    babImage.innerHTML = `<img src="${pSProduct.featured_image}&width=120" alt="${pSProduct.title}"></div>`;

    const closeElement = document.createElement('div');
    closeElement.classList.add('bab-item-cell-close');
    closeElement.innerHTML = '<svg class="icon icon-close" width="100%" height="100%" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 9L5 5M5 5L9 1M5 5L1 1M5 5L9 9" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    babItemContainer.insertAdjacentElement('beforeend', babImage);
    babItemContainer.insertAdjacentElement('beforeend', closeElement);

    if(addedItems.length > 7){
      babItem.insertAdjacentElement('beforeend', babItemContainer);
      
      const itemList = this.querySelector('.bab-items-list');

      itemList.insertAdjacentElement('beforeend', babItem);
    }else{
      const selectedItem = this.querySelector(`[data-index="${itemIndex}"].bab-item-cell`);

      selectedItem.classList.add('js-item-cell');
      selectedItem.setAttribute('data-productid', pSProduct.id);
      selectedItem.insertAdjacentElement('beforeend', babItemContainer);
    }

    closeElement.addEventListener('click', (e) => {
      const selectedProductId = e.target.closest('.js-item-cell').getAttribute('data-productid');
      const productCell = this.querySelector(`.bundle-card-product[data-productid="${selectedProductId}"]`);

      this.removeItemWidget(selectedProductId);
      if(productCell){
        const qtyInput = productCell.querySelector('.quantity__input');
        qtyInput.stepDown();
        qtyInput.dispatchEvent(this.changeEvent);
      }
    })
  }

  removeItemWidget(productId){
    const addItems = this.querySelectorAll('.js-item-cell');

    if(!addItems.length > 0) return false;

    const selectedItem = this.querySelector(`.js-item-cell[data-productid="${productId}"]`);
    if(selectedItem){
      selectedItem.remove();
    }

    const updatedItems = this.querySelectorAll('.js-item-cell');

    updatedItems.forEach((updatedItem, index) => {
      //console.log('updatedItem', updatedItem, index);
      updatedItem.setAttribute('data-index', index + 1);
    })

    if(updatedItems.length < 8){
      const itemsList = this.querySelector('.bab-items-list');

      itemsList.innerHTML = '';
      for (let index = 0; index < 8; index++) {
        const element = updatedItems[index];
        
        if(element){
          itemsList.insertAdjacentElement('beforeend', element);
        }else{
          const blankItem = `<div class="bab-item-cell" data-index="${index + 1}"><div class="bab-item-cell-blank"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-plus" fill="none" viewBox="0 0 10 10">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor">
          </path></svg></div></div>`;

          itemsList.insertAdjacentHTML('beforeend', blankItem);
        }
      }
    }
  }

  priceUpdate(){
    const cProducts = this.querySelectorAll('.bundle-card-product');
    const subPrices = this.querySelectorAll('.bab-sub-price');
    const subCPrices = this.querySelectorAll('.bab-sub-cross-price');
    let onePrice = 0;
    let subPrice = 0;
    
    cProducts.forEach(element => {
      const productId = element.getAttribute('data-productid');
      const pSProduct = bnproductsData.find((product) => product.id == productId);
      const qtyInput = element.querySelector('input.quantity__input');
      const productQty = qtyInput.value;

      if(parseInt(productQty) > 0){
        const firstVariant = pSProduct.variants[0];

        if(firstVariant.available){
          onePrice = onePrice + firstVariant.price * productQty;
          subPrice = subPrice + firstVariant.selling_plan_allocations[0].per_delivery_price * productQty;
        }
      }
    });

    subPrices.forEach(sprice => {
      sprice.innerHTML = formatMoney(subPrice);
    });

    subCPrices.forEach(scprice => {
      scprice.innerHTML = formatMoney(onePrice);
    });
  }

  progressUpdate(){
    const cProducts = this.querySelectorAll('.bundle-card-product');
    const fCounts = this.querySelectorAll('.progress-step-f-count');
    const sCounts = this.querySelectorAll('.progress-step-s-icons');
    const tCounts = this.querySelectorAll('.progress-step-t-icons');
    const progressBars = this.querySelectorAll('.progress-bar-active');
    const progressNotifications = this.querySelectorAll('.progress-notification');
    const selectedOption = this.querySelector('input[name="Bab Sub Input"]:checked');
    const babAtc = this.querySelector('.js-bab-atc');
    let tPrice = 0;
    let minPrice = 3000;
    let maxQty = 20;
    let freeShippingLimit = 8000;
    let onePrice = 0;
    let subPrice = 0;

    cProducts.forEach(element => {
      const productId = element.getAttribute('data-productid');
      const pSProduct = bnproductsData.find((product) => product.id == productId);
      const qtyInput = element.querySelector('input.quantity__input');
      const productQty = qtyInput.value;

      if(parseInt(productQty) > 0){
        const firstVariant = pSProduct.variants[0];

        if(firstVariant.available){
          onePrice = onePrice + firstVariant.price * productQty;
          subPrice = subPrice + firstVariant.selling_plan_allocations[0].per_delivery_price * productQty;
        }
      }
    });

    if(selectedOption.value == 'sub'){
      tPrice = subPrice;
    }else{
      tPrice = onePrice;
    }

    if(tPrice >= minPrice){
      fCounts.forEach((fCount) => {
        fCount.classList.add('active');
      });
      progressBars.forEach((progressBar) => {
        progressBar.style.width = '50%';
      });
      babAtc.classList.remove('disabled');
      babAtc.removeAttribute('disabled');
      if(selectedOption.value == 'sub'){
        if(subPrice >= freeShippingLimit){
          sCounts.forEach((sCount) => {
            sCount.classList.add('active');
          });
          progressBars.forEach((progressBar) => {
            progressBar.style.width = '75%';
          });
          progressNotifications.forEach((progressNotification) => {
            progressNotification.innerHTML = `<span>Keep filling your box or <a href="/checkout">Checkout</a></span>`;
          });
        }else{
          sCounts.forEach((sCount) => {
            sCount.classList.remove('active');
          });
          progressNotifications.forEach((progressNotification) => {
            progressNotification.innerHTML = `<span>Add ${formatMoney(freeShippingLimit - subPrice)}  for Free Delivery!</span>`;
          });
        }
        babAtc.innerText = `CHECKOUT • ${formatMoney(subPrice)}`;
      }else{
        if(onePrice >= freeShippingLimit){
          progressBars.forEach((progressBar) => {
            progressBar.style.width = '75%';
          });
          sCounts.forEach((sCount) => {
            sCount.classList.add('active');
          });
          progressNotifications.forEach((progressNotification) => {
            progressNotification.innerHTML = `<span>Keep filling your box or <a href="/checkout">Checkout</a></span>`;
          });
        }else{
          sCounts.forEach((sCount) => {
            sCount.classList.remove('active');
          });
          progressNotifications.forEach((progressNotification) => {
            progressNotification.innerHTML = `<span>Add ${formatMoney(freeShippingLimit - onePrice)}  for Free Delivery!</span>`;
          });
        }
        babAtc.innerText = `CHECKOUT • ${formatMoney(onePrice)}`;
      }
    }else{
      sCounts.forEach((sCount) => {
        sCount.classList.remove('active');
      });
      fCounts.forEach((fCount) => {
        fCount.classList.remove('active');
      });
      babAtc.classList.add('disabled');
      babAtc.setAttribute('disabled', 'disabled');
      if(tPrice == 0){
        progressBars.forEach((progressBar) => {
          progressBar.style.width = '0%';
        });
      }else{
        let pPercent = (50 / minPrice) * tPrice;
        progressBars.forEach((progressBar) => {
          progressBar.style.width = `${pPercent}%`;
        });
      }
      progressNotifications.forEach((progressNotification) => {
        progressNotification.innerHTML = `<span>Add ${formatMoney(minPrice - tPrice)} meals to get started!</span>`;
      });
      babAtc.innerText = `Add ${formatMoney(minPrice - tPrice)} more meals`;
    }
  }

  validateQtyRules(event) {
    const qtyWrap = event.target.closest('quantity-input');
    const qtyInput = qtyWrap.querySelector('input');
    const value = parseInt(qtyInput.value);
    if (qtyInput.min) {
      const min = parseInt(qtyInput.min);
      const buttonMinus = qtyWrap.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (qtyInput.max) {
      const max = parseInt(qtyInput.max);
      const buttonPlus = qtyWrap.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }

  buildBoxCart(event){
    event.preventDefault();
    
    const cProducts = this.querySelectorAll('.bundle-card-product');
    const selectedOption = this.querySelector('input[name="Bab Sub Input"]:checked');
    const selectedFre = this.querySelector('select.bab-sub-select').value;
    let items = [];

    cProducts.forEach(element => {
      const productId = element.getAttribute('data-productid');
      const pSProduct = bnproductsData.find((product) => product.id == productId);
      const qtyInput = element.querySelector('input.quantity__input');
      const productQty = qtyInput.value;
      const sellingPlans = pSProduct.selling_plan_groups[0].selling_plans;
      const selectedSellingPlan = sellingPlans.find((plan) => plan.name == selectedFre);

      if(parseInt(productQty) > 0){
        const firstVariant = pSProduct.variants[0];
        let item = {};

        if(selectedOption.value == 'sub'){
          item = {
            id: firstVariant.id,
            quantity: parseInt(productQty),
            selling_plan: selectedSellingPlan.id
          };
        }else{
          item = {
            id: firstVariant.id,
            quantity: parseInt(productQty)
          }
        }

        items.push(item);
      }
    });

    if(items.length > 0){
      const cartData = {
        items: items,
      };
      fetch(`${window.Shopify.routes.root}` + 'cart/clear.js', {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
      }).then(response => {
          fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json'
              },
              body: JSON.stringify(cartData)
          })
          .then(response => {
              return response.json();
          })
          .then(response => {
              window.location.href = '/cart';
          })
          .catch((error) => {
              console.error('Error:', error);
          });
      });
    }
  }
}

customElements.define('build-a-box', BuildaBox);